import { render, staticRenderFns } from "./AddressNormalizationModal.vue?vue&type=template&id=bc6dd960"
import script from "./AddressNormalizationModal.vue?vue&type=script&lang=js"
export * from "./AddressNormalizationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports